import useUser from "@saleor/hooks/useUser";
import {
  ProductUserViewEnum,
  SmopUserTypeCode
} from "@saleor/types/globalTypes";

import { ProductsUser } from "../customTypes/ProductsUser";

function productUserFactory(params): ProductsUser {
  const user = useUser();

  return {
    id: user.userDetail.id,
    isKAMS:
      user.userDetail.accessGroup !== null &&
      user.userDetail.accessGroup.smopUsertypeCode ===
        SmopUserTypeCode.ACCOUNT_MANAGER,
    isSellerMaster:
      getUserType(user, params) === ProductUserViewEnum.SELLER_MASTER,
    isStoreAdmin: getUserType(user, params) === ProductUserViewEnum.STORE_ADMIN,
    isSuperUser: user.userDetail.accessGroup === null,
    userType: getUserType(user, params)
  };
}

// getUserType can return either the actual user type code of currently logged in non-KAMS user
// or the user view selected by a logged in KAMS user
// This function also returns a value of "SUPERUSER" if logged in user is super user
// The superuser user type has no user type information, hence the access group value of 'null'
function getUserType(user, params) {
  return user.userDetail.accessGroup === null
    ? "SUPERUSER"
    : getKAMSUserViewFromParams(params);
}

// getKAMSUserViewFromParams returns the user view value from params if user logged in as KAMS
// If user logged in is non-KAMS, the actual user type code is returned with a value of SmopUserTypeCode type
function getKAMSUserViewFromParams(params) {
  const user = useUser();
  return user.userDetail.accessGroup.smopUsertypeCode ===
    SmopUserTypeCode.ACCOUNT_MANAGER && params.viewAs !== undefined
    ? (params.viewAs as ProductUserViewEnum)
    : user.userDetail.accessGroup.smopUsertypeCode;
}

export default function useProductUserType(params): ProductsUser {
  return productUserFactory(params);
}
